export function getCreateRequestPayloadInitialValues(payload) {
  return (
    payload?.formProps?.initialValues ?? payload?.wizardProps?.initialValues
  )
}

export function getCreateRequestSubmitPayload(payload, initialValues) {
  return {
    ...payload,
    formProps: { ...payload?.formProps, initialValues },
    wizardProps: { ...payload?.wizardProps, initialValues },
  }
}
